(function () {

  $(document).on('click', '[data-action=\'remove-upload\']', function (ev) {
    ev.preventDefault();

    if (confirm('Remove this image?')) {
      var $this = $(this);
      var $parent = $this.parents('[data-role="upload-item"]');
      $parent.remove();
    }
  });

  $(document).on('change', '[data-form=\'register-upload\']', function (ev) {
    var field = this;
    var $this = $(this);
    var $form = $this.parents('[data-registerform]');
    var $uploadContainer = $form.find('[data-form="uploads"]');
    var link_id = $form.attr('data-registerform');
    var data = $form.serializeObject();

    var actualSize = $('[data-role="upload-item"]').length;
    var limit = 5;

    if (actualSize > limit) return;

    for (var i = 0, x = field.files.length; i < x; i++) {
      if ((actualSize + (i+1)) > limit) continue;

      (function (key) {
        var file = field.files[key];
        var extension = file.name.split('.').pop().toLowerCase();

        $.ajax({
          url: '/widget-api/' + link_id,
          type: 'POST',
          data: {
            __action: 'upload-item',
            name: file.name,
            extension: extension
          },
          success: function (r) {
            var $item = $(r.data);
            $item.appendTo($uploadContainer);
            var formData = new FormData();

            var $uploadName = $item.find('[data-upload="name"]');
            var $uploadId = $item.find('[data-upload="id"]');
            var $preview = $item.find('[data-upload="preview"]');
            var $progress = $item.find('[data-upload="progress"]');
            var $progressBar = $item.find('[data-upload="progress-bar"]');

            var progressCb = function (event) {
              var percent = 0;
              var position = event.loaded || event.position;
              var total = event.total;
              if (event.lengthComputable) {
                percent = Math.ceil(position / total * 100);
              }

              $progressBar.width(percent + '%');
              $progress.text(percent + '%');
            };

            formData.append('__action', 'upload');
            formData.append('files', file);

            $.ajax({
              url: '/widget-api/' + link_id + '/upload',
              type: 'POST',
              cache: false,
              contentType: false,
              processData: false,
              xhr: function () { // custom xhr
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) { // if upload property exists
                  myXhr.upload.addEventListener('progress', progressCb, false); // progressbar
                }
                return myXhr;
              },
              data: formData,
              error: function (r) {
                $item.remove();
                notify('The file is not an image, or is too large.', 'error');
              },
              success: function (r) {
                console.log(r[0])
                $preview.attr('src', r[0].thumb).show();
                $uploadId.val(r[0].id);
                $uploadName.text(r[0].originalName).attr('title', r[0].originalName);
              }
            });
          }
        });
      })(i);
    }

  });

  $(document).on('change', '[data-form="designer-select"]', function (ev) {
    var $this = $(this);
    var $designerNameField = $('[data-form="designer-name"]');

    if ($this.val() === 'other') {
      $designerNameField.removeClass('hidden');
    } else {
      $designerNameField.addClass('hidden');
    }
  });

  $('[data-form="designer-select"]').change();

  $(document).on('submit', '[data-registerform]', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var link_id = $this.attr('data-registerform');
    var data = $this.serializeObject();

    data.__action = 'save';

    $.post('/widget-api/' + link_id, data, function (r) {
      if (r.status === true) {
        notify('Register submitted successfully.');
        $this[0].reset();
        $this.find('[data-role="upload-item"]').remove();
        $this.find('select').trigger('change');
      } else {
        notify('Register can\'t be submitted now, please try again later.', 'error');
      }
    });
    
  });
})();